import React, { Component } from 'react';
//import {Alert} from 'react-bootstrap';
import { Table, Jumbotron, Button, Form, Col, Row, Container } from 'react-bootstrap';
//import {Toast} from 'react-bootstrap';
// ;
import config from '../../../config';

import SearchItem from '../../subcomponent/searchItem';
//import errores from '../../middleware/errordb'
//import funciones from '../../middleware/funciones';
//import { Header } from 'react-bootstrap/lib/Modal';
import ModalConfirm from '../../subcomponent/modalConfirm';
import BackButton from '../../widgets/back_button';

class Precios extends Component {
    constructor(props) {
        const currentCompany = sessionStorage.getItem('company');
        const currentUserType = sessionStorage.getItem('tipo');
        super(props);
        this.state = {
            data: [],
            items: [],
            empresa: currentCompany,
            tipo: currentUserType,
            mostrarMensaje: false,
            mensaje: "",
            busqueda: "",
            precio_producto: 0,
            itemDescriptionSelect: "",
            cItem: [],
            codigo_lista: "",
            nombre_lista: ""
        };
    }
    componentDidMount() {
        const { search } = this.props.location;
        const listid = search.replace('?', '');
        const datasend = {
            method: 'GET',

            headers: {
                'Content-Type': 'application/json',
                'empresa': this.state.empresa,
                'tipo': this.state.tipo,
            }
        }
        fetch(config.servBackEnd + '/prices/product/' + listid, datasend).then(response => response.json())
            .then(data => {
                const infoList = data[2][0];
                this.setState({
                    data: data[0],
                    items: data[1],
                    codigo_lista: infoList.CODIGO_LISTA_PRECIOS,
                    nombre_lista: infoList.NOMBRE_LISTA
                })
            });
    }

    nuevoProducto = () => {
        const { cItem } = this.state;
        if (cItem.ID_ITEMS) {
            const { search } = this.props.location;
            const listid = search.replace('?', '');
            const { precio_producto } = this.state;
            const { data } = this.state;
            const { empresa } = this.state;
            const producto = cItem.ID_ITEMS;
            let control = 0;

            data.forEach(element => {
                if (element.ID_ITEM.toString() === producto.toString()) {
                    control++;
                }
            });
            if (control === 0) {
                data.push({
                    ID_PRECIOS: cItem.ID_ITEMS,
                    CODIGO_ITEM: cItem.CODIGO_ITEM,
                    DESCRIPCION_ITEM: cItem.DESCRIPCION_ITEM,
                    ID_EMPRESA: empresa,
                    ID_ITEM: cItem.ID_ITEMS,
                    ID_LISTA_PRECIOS: listid,
                    PRECIO: precio_producto,
                    REFERENCIA_ITEM: cItem.REFERENCIA_ITEM,
                    NEW: 1,
                    CHANGE: 1
                })
            };
            this.setState({
                data,
                itemDescriptionSelect: "",
                precio_producto: 0,
                cItem: []
            })
        }
    }

    updateArray = ({ target }) => {
        const { id } = target;
        const { value } = target;
        const dataNew = this.state.data;

        dataNew.forEach(element => {
            if (element.ID_PRECIOS.toString() === id.toString()) {
                element.PRECIO = value;
                element.CHANGE = true;
            }
        });
        this.setState({ data: dataNew });
    }

    guardar = () => {
        event.preventDefault();
        this.setState({ show: true });
    }

    enviarInfo = () => {
        this.setState({ show: false });
        const { data } = this.state;
        const newData = [];

        data.forEach(element => {
            if (element.NEW || element.CHANGE) {
                newData.push(element);
            }
        });

        const datasend = {
            method: 'POST',
            body: JSON.stringify(newData),
            headers: {
                'Content-Type': 'application/json',
                'tipo': this.state.tipo,
            }
        };

        data.forEach(element => {
            element.CHANGE = false;
            element.NEW = false;
            element.CONFIRMACION = "";
        });

        this.setState({ data });

        fetch(config.servBackEnd + '/prices/products/save', datasend).then(response => response.json())
            .then(data => {
                const cData = this.state.data;
                data.forEach(element => {
                    cData.forEach(element2 => {
                        if (element.ID_ITEM === element2.ID_ITEM) {
                            element2.ID_PRECIOS = element.ID_PRECIOS
                            element2.CONFIRMACION = (element.ok) ? 'ok' : 'error';
                        }
                    });
                });
                this.setState({
                    data: cData,
                    itemDescriptionSelect: "",
                    precio_producto: 0,
                    cItem: []
                });
            });
    };

    selectItem = (itemSelect) => {
        this.setState({
            itemDescriptionSelect: itemSelect.DESCRIPCION_ITEM,
            cItem: itemSelect,
            busqueda: itemSelect.REFERENCIA_ITEM
        })
    }

    handleClose = () => {
        this.setState({ show: false });
    };

    render() {
        const mensajeConfirm = "¿Está seguro que desea guardar los cambios?";
        const dato = this.state.data;
        const items = this.state.items;
        const { busqueda } = this.state;
        //funciones
        const updateArray = this.updateArray;

        const style = {
            color: "white",
            backgroundColor: "DodgerBlue",
            padding: "10px",
            fontFamily: "Arial"
        };
        return (
            <div className="contenedor">

                <div>
                    <ModalConfirm show={this.state.show} enviarInfo={this.enviarInfo} handleClose={this.handleClose} mensaje={mensajeConfirm}   ></ModalConfirm>
                </div>
                <Jumbotron style={style}>
                    <h1>Detalle de Precios {this.state.nombre_lista}({this.state.codigo_lista})</h1>
                </Jumbotron>
                <BackButton />
                <Container>
                    <Row>
                        <Col>
                            <SearchItem data={items} event={this.selectItem} ></SearchItem>
                        </Col>
                        <Col>
                            <Form>
                                <Form.Row>
                                    <Form.Group as={Col} controlId="producto">
                                        <Form.Label>PRODUCTO</Form.Label>
                                        <Form.Control type="text" value={this.state.itemDescriptionSelect} readOnly />
                                    </Form.Group>
                                    <Button className="plus" size="sm" onClick={this.guardar} variant="outline-success">Guardar Cambios</Button>
                                </Form.Row>
                                <Form.Row>
                                    <Form.Group as={Col} controlId="precio">
                                        <Form.Label>PRECIO</Form.Label>
                                        <Form.Control type="number" placeholder="precio" onChange={e => this.setState({ precio_producto: e.target.value })} value={this.state.precio_producto} required />
                                    </Form.Group>
                                    <Button className="plus" size="sm" onClick={this.nuevoProducto} variant="outline-primary">Adicionar Precio</Button>
                                </Form.Row>
                            </Form>
                            <Table hover responsive size="sm" className="table">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>CODIGO</th>
                                        <th>REFERENCIA</th>
                                        <th>DESCRIPCION</th>
                                        <th>PRECIO</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {dato.map(function (currentData, index) {
                                        if (currentData.REFERENCIA_ITEM.toLowerCase().search(busqueda.toLowerCase()) > -1
                                            || currentData.DESCRIPCION_ITEM.toLowerCase().search(busqueda.toLowerCase()) > -1) {
                                            return <tr key={index + "d0"}>
                                                <td>{currentData.CONFIRMACION}</td>
                                                <td key={index + "d2"}>{currentData.CODIGO_ITEM}</td>
                                                <td key={index + "d3"}>{currentData.REFERENCIA_ITEM}</td>
                                                <td key={index + "d4"}>{currentData.DESCRIPCION_ITEM}</td>
                                                <td key={index + "d6"}><input type="text" id={currentData.ID_PRECIOS} onChange={updateArray} defaultValue={currentData.PRECIO} /> </td>
                                            </tr>;
                                        }
                                        else {
                                            return null;
                                        }
                                    })}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                </Container >
            </div >
        );
    }
}
export default (Precios);


// WEBPACK FOOTER //
// ./src/components/bussines/catalogos/precios.jsx